import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { CollectionEntryState } from '../hooks/useExplorerState/useEditorTabState/collectionEntryState';

export function collectionEntryStateToInput(
  collectionEntryState: CollectionEntryState,
): GraphQLTypes.OperationCollectionEntryStateInput {
  return {
    body: collectionEntryState.operation ?? '',
    variables: collectionEntryState.variables,
    headers: collectionEntryState.headers?.map((header) => ({
      name: header.headerName,
      value: header.value,
    })),
    script: collectionEntryState.preflightOperationScript,
    postflightOperationScript: collectionEntryState.postflightOperationScript,
  };
}
